export enum ROUTES {
  DONATE = "/faites-un-don",
  HOMEPAGE = "/",
  PROJECT = "/projet/:id",
  PROJECT_COMING = "/projects-coming/:id",
  PROJECT_ON_GOING = "/projects-on-going/:id",
  PROJECTS = "/projets",
  PROJECTS_COMING = "/projects-coming",
  PROJECTS_ON_GOING = "/projects-on-going",
}

export enum MAIN_MENU {
  ABOUT_US = "about-us",
  ACTIVITIES = "activities",
  CONTACT = "contact",
  NONE = "",
  PROJECTS = "projects",
  PROJECTS_DONE = "projects-done",
  PROJECTS_ONGOING = "projects-ongoing",
  PROJECTS_COMING = "projects-coming",
}

export enum PROJECT_STATUS {
  EXECUTED = "EXECUTED",
}
